import vuetify from './plugins/vuetify';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';

import filters from './filters';
import VueQriously from 'vue-qriously'

import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'
Vue.use(vueMiniPlayer)

Vue.use(VueQriously)



for(let key in filters){
  // eslint-disable-next-line no-prototype-builtins
  if(filters.hasOwnProperty(key)){
    Vue.filter(key, filters[key])
  }
}

Vue.use(VueAxios, axios);
// axios.defaults.baseURL = 'http://localhost';
axios.defaults.baseURL = 'https://api.manage.tsyungu.com';

axios.defaults.withCredentials = true;

Vue.config.productionTip = false;


axios.interceptors.response.use(
  response => {

    return response
  },
  error => {
    switch (error.response.status) {
      case 401:
        router.replace('/login').catch(err => {err});
        break;
      case 403:
        console.error('没有权限');
        break;
    }
  }
);

router.afterEach(() => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
